import { TelemetryErrorEvent } from '../../utilities/insights/models/telemetry-error-event';

export class DocViewerAccessDeniedError extends TelemetryErrorEvent {
	constructor(error: Error, docId: string) {
		super({ internalError: error });
		this.name = 'doc-viewer-access-denied-error';
		this.context.message = "DocViewer access denied for document.";
		this.context.docId = docId;
	}
}
